export const iconFontAwesomeSpinnersArrowsSpin = (
	<i className="fa-solid fa-arrows-spin"></i>
);
